import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_quote,
  get_quote,
  update_quote,
} from "../../../../Controllers/Sales/Quotes";
import forms from "../../../../Data/Forms/Sales/Quotes/forms";
import headers from "../../../../Data/Forms/Sales/Quotes/headers";
import Loadercomponent from "../../../../Componets/Loader";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import Quotetable from "../../../../Data/Forms/Sales/Quotes/table";

const QuotesForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);
  const [header, setHeader] = useState(headers);

  const [details, setDetails] = useState([]);
  const [totals, setTotals] = useState({
    subtotal: "0.000",
    taxamount: "0.000",
    discount: 0,
    delivery: 0,
    total: "0.000",
    valid_until: "",
    payment_terms: "",
  });
  const [note, setNote] = useState("");

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      try {
        const quoteData = {
          ...data?.data,
          details: details,
          subtotal: totals?.subtotal,
          taxamount: totals?.taxamount,
          discount: totals?.discount,
          delivery: totals?.delivery,
          total: totals?.total,
          valid_until: totals?.valid_until,
          payment_terms: totals?.payment_terms,
          note: note,
        };

        const quote = id
          ? await update_quote({
            ...quoteData,
            id: id,
          })
          : await create_quote(quoteData);

        if (quote?.status) {
          toast?.success(quote?.message);
          setButtonLoader(false);
          navigate(-1);
        } else {
          setButtonLoader(false);
          if (quote?.status_code == 403) {
            window.location.href = "/unauthorized";
          } else {
            toast?.error(quote?.message);
          }

        }
      } catch (error) {
        toast?.error("Failed to save quote");
        setButtonLoader(false);
      }
    }
  };

  const handleData = (quote) => {
    let customer = quote?.customer?._id ? quote?.customer?._id : null;
    let number = quote?.number ? quote?.number : "";
    let date = quote?.date ? quote?.date : "";
    let due_date = quote?.due_date ? quote?.due_date : "";
    let status = quote?.status !== undefined ? quote?.status : 1;

    let customer_option = quote?.customer?._id
      ? [
        {
          value: quote?.customer?._id,
          label: quote?.customer?.name,
        },
      ]
      : null;

    const updatedValues = [...values];
    updatedValues[0].options[0].form.value = customer;
    updatedValues[0].options[0].form.options = customer_option;
    updatedValues[0].options[1].form.value = number;
    updatedValues[0].options[2].form.value = date;
    updatedValues[0].options[3].form.value = due_date;
    updatedValues[0].options[4].form.value = status;

    let data = [];
    if (quote?.details && quote.details.length > 0) {
      quote.details.forEach((value, index) => {
        data.push({
          id: value?._id,
          description: value?.description._id,
          name: value?.name,
          batch: value?.batch ? value?.batch : value?.description?.number,
          expiry_date: value?.expiry_date,
          unit: value?.unit,
          unit_name: value?.unit_name,
          quantity: value?.quantity,
          free: value?.free,
          sale_price: value?.sale_price,
          retail_price: value?.retail_price,
          stock: value?.stock ? value?.stock : value?.description?.stock,
          tax: value?.tax?.name ? value?.tax?.name : null,
          tax_details: value?.tax,
          tax_amount: value?.tax_amount,
          total: value?.total,
          discount_price: value?.discount_price,
          discount_percentage: value?.discount_percentage,
          price_per_unit: value?.price_per_unit,
          unit_details_options: value?.unit_details_options || [],
          summary: value?.quote_summary,
          options: [
            {
              value: value?.description?._id,
              label: value?.description?.name,
            },
          ],
        });
      });
    } else {
      data.push({
        id: "",
        description: null,
        name: "",
        unit: "",
        unit_name: "",
        quantity: "",
        sale_price: "",
        retail_price: "",
        stock: "",
        tax: 0,
        free: "",
        tax_amount: "0.000",
        total: 0,
        discount_price: "",
        discount_percentage: "",
        price_per_unit: "",
        unit_details_options: [],
        summary: "",
      });
    }

    const updatedTotals = {
      subtotal: quote?.subtotal || "0.000",
      taxamount: quote?.taxamount || "0.000",
      discount: quote?.discount || 0,
      delivery: quote?.delivery || 0,
      total: quote?.total || "0.000",
      valid_until: quote?.valid_until || "",
      payment_terms: quote?.payment_terms || "",
    };

    setNote(quote?.note || "");

    setValues(updatedValues);
    setDetails(data);
    setTotals(updatedTotals);
    setLoader(false);
  };

  const findFieldIndex = (fieldName) => {
    return values[0].options.findIndex((option) => option.name === fieldName);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);
      try {
        const data = { id: id };
        const quote = await get_quote(data);
        if (quote?.status) {
          handleData(quote?.data);
        } else {
          toast?.error(quote?.message);
          setLoader(false);
        }
      } catch (error) {
        toast?.error("Failed to fetch quote data");
        setLoader(false);
      }
    } else {

      const dateIndex = findFieldIndex("Date");

      if (dateIndex !== -1) {
        values[0].options[dateIndex].form.value = new Date();
      }

      setDetails([
        {
          id: "",
          description: null,
          name: "",
          unit: "",
          unit_name: "",
          quantity: "",
          sale_price: "",
          retail_price: "",
          stock: "",
          tax: 0,
          free: "",
          tax_amount: "0.000",
          total: 0,
          discount_price: "",
          discount_percentage: "",
          price_per_unit: "",
          unit_details_options: [],
          summary: "",
        },
      ]);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        >
          <Bodycomponent>
            <Titlecomponent index={1} title={"Items"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={true} />
              <Quotetable
                details={details}
                setDetails={setDetails}
                totals={totals}
                setTotals={setTotals}
                note={note}
                setNote={setNote}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default QuotesForm;